import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import HText from "../components/HText";

import {motion} from 'framer-motion';
import { Navigation, Pagination,  A11y } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

import { SelectedPage, works } from "../shared/data";
import PortfolioCard from '../components/PortfolioCard';


const Portfolio = ({setSelectedPage}) => {
return (
    <section
    id="projects"
    className="py-20 md:h-full md:py-32"
    >
        <motion.div
        onViewportEnter={() => setSelectedPage(SelectedPage.Projects)}
        className="flex flex-col gap-20 p-20">
            <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{delay: 0.2, duration: 0.5 }}
            variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
            }}
            className='relative flex items-center justify-center '
            >
                <HText text={"Portfolio"}/>
            </motion.div>
            <div className="grid gap-x-4 gap-y-5
            grid-cols-[repeat(auto-fill,minmax(280px,_1fr))]">
                {
                    works.map(({imgSrc, title, tags, projectLink}, key) => (
                        <PortfolioCard
                        key={key}
                        imgSrc={imgSrc}
                        title={title}
                        tags={tags}
                        projectLink={projectLink}
                        />
                    ))
                }
            </div>

            </motion.div>
    </section>
    )
}

export default Portfolio


/**
 *     <section
    id="projects"
    className="py-20 md:h-full md:py-32"
    >
        <motion.div
        onViewportEnter={() => setSelectedPage(SelectedPage.Projects)}
        className="flex flex-col items-center justify-center">
            <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{delay: 0.2, duration: 0.5 }}
            variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
            }}
            className='relative flex items-center justify-center '
            >
                <HText text={"Portfolio"}/>
            </motion.div>
            
            <Swiper 
            breakpoints={{
                324:{
                slidesPerView:1,
                spaceBetween:10
                },
                768:{
                slidesPerView:2,
                spaceBetween:10
                },
                1060:{
                slidesPerView:2,
                spaceBetween:10
                },
                1200:{
                slidesPerView: 3,
                spaceBetween: 10
                }
            }}
            modules={[Navigation, Pagination, A11y]}
            navigation
            pagination={{ clickable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log('slide change')}
            className="w-[80%] relative"
            >
                {ServiceData.map((item) => (
                <SwiperSlide>
                
                </SwiperSlide>
                ))}
            </Swiper>
            </motion.div>
    </section>
 */